import { render, staticRenderFns } from "./U8DeliveryOrderReporttable.vue?vue&type=template&id=16a06ea0&scoped=true&"
import script from "./U8DeliveryOrderReporttable.vue?vue&type=script&lang=js&"
export * from "./U8DeliveryOrderReporttable.vue?vue&type=script&lang=js&"
import style0 from "./U8DeliveryOrderReporttable.vue?vue&type=style&index=0&id=16a06ea0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a06ea0",
  null
  
)

export default component.exports